import { FacetFiltersForm } from "../utilities/FacetFiltersForm";
import { PriceRange } from "../utilities/PriceRange";
import { FacetRemove } from "../utilities/FacetRemove";
import { addSwatchLabels, rebuildExtraCounters, getSwatchWrappers } from "../utilities/addSwatchLabels";
import { isDesktop, isMobile } from "../utilities/screenSize";
import { simulateClick } from "../utilities/Helpers/helpers";
import Ajaxinate from "ajaxinate";
import Cookies from "js-cookie";
import { _addEventListener } from "../utilities/Helpers/eventHelper";
import { swatchUrlChanger } from "../utilities/Helpers/UI/SwatchUrlChanger";
import Modal from "../utilities/Helpers/UI/Modal";
import { hideFocusVisibility, showFocusVisibility } from "../utilities/Helpers/Accesibility/ModalFocusTrapHelper";
import {
    adjustAllSwatchPositions,
    observeAndAdjustSwatchPositions,
} from "../utilities/Helpers/UI/SwatchHelperToA11y";

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();
customElements.define("price-range", PriceRange);
customElements.define("facet-remove", FacetRemove);

LUC.jsCollection = {
    init: function ($section) {
        LUC.jsCollection.changeLayout();
        LUC.jsCollection.clickMenuFilters();
        LUC.jsCollection.closeMenuFilters();
        LUC.jsCollection.loadMoreProducts();
        LUC.jsCollection.doneFilterBtnClick();
        LUC.jsCollection.clickOnPopularFilters();
        LUC.jsCollection.paginateLastStepHandler();
        addSwatchLabels(getSwatchWrappers());
        swatchUrlChanger(getSwatchWrappers());
    },

    changeLayout: function () {
        const gridLayoutAbTest = LUC.ABTests["test-grid-layout-on-plp"];
        let gridOneDefault = document.querySelector('[data-facets-grid="one"]');
        let gridMediumDefault = document.querySelector('[data-facets-grid="medium"]');
        if (gridLayoutAbTest) {
            gridOneDefault = document.querySelector(
                '[data-facets-grid="' + gridLayoutAbTest.variantValue.mobile + '"]'
            );
            gridMediumDefault = document.querySelector(
                '[data-facets-grid="' + gridLayoutAbTest.variantValue.desktop + '"]'
            );
        }
        const facetGrids = document.querySelectorAll("[data-facets-grid]");
        if (facetGrids) {
            LUC.jsCollection.clearGridClasses(facetGrids);
        }
        const cookieLayoutTypeValue = Cookies.get("plp_layout_type");
        const gridContainer = document.querySelector("[data-grid-layout]");
        if (cookieLayoutTypeValue) {
            if (gridContainer) {
                if (isDesktop()) {
                    if (cookieLayoutTypeValue == "medium" || cookieLayoutTypeValue == "large") {
                        gridContainer.dataset.gridLayout = cookieLayoutTypeValue;
                    } else {
                        gridContainer.dataset.gridLayout = "medium";
                    }
                } else if (cookieLayoutTypeValue == "half") {
                    gridContainer.dataset.gridLayout = cookieLayoutTypeValue;
                } else {
                    gridContainer.dataset.gridLayout = "one";
                }
                const facetBtn = document.querySelector(
                    '[data-facets-grid="' + gridContainer.dataset.gridLayout + '"]'
                );
                if (facetBtn) {
                    facetBtn.classList.add("active");
                }
            }
        } else {
            if (isDesktop()) {
                gridContainer.dataset.gridLayout = gridLayoutAbTest.variantValue.desktop;
                gridMediumDefault.classList.add("active");
            } else {
                gridContainer.dataset.gridLayout = gridLayoutAbTest.variantValue.mobile;
                gridOneDefault.classList.add("active");
            }
        }
        if (isMobile()) {
            adjustAllSwatchPositions(cookieLayoutTypeValue, gridContainer.querySelectorAll("li[data-handle]"));
        }
        if (facetGrids) {
            facetGrids.forEach((facet) => {
                facet.addEventListener("click", (event) => {
                    event.preventDefault();
                    const layoutType = facet.dataset.facetsGrid;
                    const gridContainer = document.querySelector("[data-grid-layout]");
                    if (gridContainer) {
                        gridContainer.dataset.gridLayout = layoutType;
                        LUC.jsCollection.clearGridClasses(facetGrids);
                        facet.classList.add("active");
                        Cookies.set("plp_layout_type", layoutType, { expires: 7 });
                        LUC.jsCollection.setDefaultGrid(layoutType);
                        rebuildExtraCounters();
                        if (isMobile()) {
                            adjustAllSwatchPositions(
                                cookieLayoutTypeValue,
                                gridContainer.querySelectorAll("li[data-handle]")
                            );
                        }
                    }
                });
            });
        }
    },

    setDefaultGrid(layoutType) {
        const gridOneDefault = document.querySelector('[data-facets-grid="one"]');
        const gridMediumDefault = document.querySelector('[data-facets-grid="medium"]');

        if (layoutType == "large" || layoutType == "medium") {
            gridOneDefault.classList.add("active");
        }

        if (layoutType == "half" || layoutType == "one") {
            gridMediumDefault.classList.add("active");
        }
    },

    clearGridClasses: function (facetsGrids) {
        if (facetsGrids) {
            facetsGrids.forEach((facet) => {
                facet.classList.remove("active");
            });
        }
    },

    clickMenuFilters: function () {
        const menuWrapper = document.querySelector("[data-facets-menu-wrapper]");
        const filterBtn = document.querySelector("[data-facets-btn-filter-menu]");
        const closefilterBtn = document.querySelector("[data-facets-btn-close-menu]");
        const htmlEl = document.querySelector("html");
        if (!menuWrapper || !filterBtn) {
            return;
        }
        Modal.getModalByName("filters");
        Modal.getModalByName("filters").onClosed = () => {
            if (filterBtn.hasAttribute("open")) {
                filterBtn.removeAttribute("open");
            }
        };
        filterBtn.addEventListener("click", () => {
            setTimeout(() => {
                if (filterBtn.hasAttribute("open")) {
                    htmlEl.style = "overflow-y: hidden";
                    Modal.getModalByName("filters").show();
                }
            }, 1);
        });

        closefilterBtn.addEventListener("click", (event) => {
            event.preventDefault();
            htmlEl.style = "overflow-y: auto";
            LUC.jsCollection.closeFilterDetails(event);
        });

        const details = menuWrapper.querySelectorAll("details");
        details.forEach((detail) => {
            detail.querySelector("summary").addEventListener("click", () => {
                if (detail.hasAttribute("open")) {
                    details.forEach((detail) => showFocusVisibility(detail.querySelector("summary")));
                    menuWrapper.classList.remove("submenu-open");
                    detail.querySelector("summary").focus();
                } else {
                    details.forEach((detail) => hideFocusVisibility(detail.querySelector("summary")));
                    menuWrapper.classList.add("submenu-open");
                }
            });
        });
    },

    closeMenuFilters: function () {
        const menuWrapperCloseBtn = document.querySelector("[data-close-facets]");

        if (!menuWrapperCloseBtn) {
            return;
        }

        menuWrapperCloseBtn.addEventListener("click", (event) => {
            event.preventDefault();
        });
    },

    loadMoreProducts: function () {
        new Ajaxinate({
            container: "#product-grid",
            pagination: "[data-pagination-next-el]",
            method: "click",
            callback: (data) => {
                const productsLength = document.querySelectorAll(".product__grid-item");
                const paginationCountLabel = document.querySelector("[data-pagination-count]");
                const progressbarEl = document.querySelector("[data-pagination-progress-bar]");
                const paginationBtn = document.querySelector("[data-pagination-next-el]");
                const bannersEl = document.querySelectorAll("[data-grid-banner]");
                const paginationMoreItems = document.querySelector("[data-pagination-more-items]");

                if (bannersEl) {
                    bannersEl.forEach((banner, index) => {
                        if (index > 0) {
                            banner.parentNode.removeChild(banner);
                        }
                    });
                }

                if (paginationCountLabel) {
                    paginationCountLabel.innerText = productsLength.length;
                }

                const paginationCountAllValue = parseInt(paginationCountLabel.dataset.paginationCountAll);

                if (progressbarEl) {
                    const progress_percent = (productsLength.length * 100) / paginationCountAllValue;
                    progressbarEl.style.width = `${progress_percent}%`;
                }
                if (productsLength.length >= paginationCountAllValue) {
                    paginationBtn.style.display = "none";
                } else {
                    const lastElements = paginationCountAllValue - productsLength.length;
                    if (lastElements <= 16) {
                        if (paginationMoreItems) {
                            paginationMoreItems.innerText = lastElements;
                            paginationBtn.setAttribute("data-pagination-last-step", "");
                            LUC.jsCollection.paginateLastStepHandler(data, lastElements);
                        }
                    }
                }

                addSwatchLabels(getSwatchWrappers());
                let loadedProducts = data.querySelectorAll("#product-grid>li[data-handle]");
                if (isMobile()) {
                    observeAndAdjustSwatchPositions(getSwatchWrappers(), loadedProducts);
                }
                //Helper to set Focus on first element after load new content
                let firstElementFromNewContent = document.querySelector(
                    '[data-handle="' + loadedProducts[0].dataset.handle + '"]'
                );
                let bodyRect = document.body.getBoundingClientRect();
                let elemRect = firstElementFromNewContent.getBoundingClientRect();
                let offset = elemRect.top - bodyRect.top;
                const parent = document.querySelector("#product-grid");
                LUC.jsCollection.moveAndFocusFakeElementToA11y(
                    firstElementFromNewContent,
                    offset,
                    parent,
                    "Loaded " + loadedProducts.length + " products"
                );
            },
        });
    },

    moveAndFocusFakeElementToA11y(relativeElement, offset, parent, content = "") {
        let focusFakeElement = document.querySelector("[data-focus-fake-element]");
        parent.insertBefore(focusFakeElement, relativeElement);
        focusFakeElement = document.querySelector("[data-focus-fake-element]");
        focusFakeElement.style.top = offset + "px";
        focusFakeElement.focus({
            preventScroll: true,
        });
        focusFakeElement.innerHTML = content;
    },

    paginateLastStepHandler: function (data = null, countElements = 16) {
        const lastStepBtn = document.querySelector("[data-pagination-last-step]");
        _addEventListener(lastStepBtn, "click", () => {
            const progressbarEl = document.querySelector("[data-pagination-progress-bar]");
            const paginationCountLabel = document.querySelector("[data-pagination-count]");

            if (progressbarEl) {
                progressbarEl.style.width = "100%";
            }

            if (paginationCountLabel) {
                const pagiantionCountAll = paginationCountLabel.dataset.paginationCountAll;
                paginationCountLabel.innerText = pagiantionCountAll;
            }

            let loadedProducts = data
                ? data.querySelectorAll("#product-grid>li")
                : document.querySelectorAll("#product-grid>li");
            let relativeElement = loadedProducts[loadedProducts.length - 1];
            let bodyRect = document.body.getBoundingClientRect();
            let elemRect = relativeElement.getBoundingClientRect();
            let offset = elemRect.top - bodyRect.top;
            const parent = document.querySelector("#product-grid");
            LUC.jsCollection.moveAndFocusFakeElementToA11y(
                relativeElement.nextElementSibling,
                offset,
                parent,
                "Loaded " + countElements + " products"
            );
        });
    },

    doneFilterBtnClick: function () {
        const doneBtns = document.querySelectorAll("[data-facets-btn-done]");
        doneBtns.forEach((doneBtn) => {
            doneBtn.addEventListener("click", (event) => {
                event.preventDefault();
                LUC.jsCollection.closeFilterDetails(event);
            });
        });
    },

    closeFilterDetails: function (event) {
        const openDetailsElement = event.target.closest("details[open]");
        if (!openDetailsElement) return;

        const summaryElement = openDetailsElement.querySelector("summary");
        openDetailsElement.removeAttribute("open");
        summaryElement.focus();
    },

    clickOnPopularFilters() {
        const popularFiltersBtns = document.querySelectorAll("[data-facets-popular]");

        popularFiltersBtns.forEach((popularFilter) => {
            popularFilter.addEventListener("click", (event) => {
                event.preventDefault();
                popularFilter.classList.toggle("active");
                const filterLabel = popularFilter.dataset.facetsPopular;
                const filterEl = document.querySelector('label[for="' + filterLabel + '"]');
                if (filterEl) {
                    simulateClick(filterEl);
                }
            });
        });
    },

    unload: function ($section) {},
};
